import React from 'react';
import { Button } from './Button';
import { Twitter, Linkedin, Youtube } from 'lucide-react';
import { useModal } from './ModalContext';
export const Footer = () => {
  const {
    openSignupModal
  } = useModal();
  return <footer className="w-full bg-cyan-100 text-white py-24 relative overflow-hidden" data-id="element-78">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-700 to-primary-800" data-id="element-79"></div>
      {/* Gradient accents */}
      <div className="absolute top-0 right-1/4 w-[500px] h-[500px] bg-gradient-to-br from-blue-500/10 to-purple-500/10 rounded-full blur-3xl" data-id="element-80"></div>
      <div className="absolute bottom-0 left-1/3 w-[600px] h-[600px] bg-gradient-to-tr from-teal-400/10 via-cyan-400/5 to-blue-400/10 rounded-[45%_55%_40%_60%] blur-3xl animate-float" style={{
      animationDelay: '1s'
    }} data-id="element-81"></div>
      <div className="absolute top-1/2 left-0 w-[400px] h-[400px] bg-gradient-to-r from-cyan-400/5 to-emerald-400/10 rounded-[60%_40%_55%_45%] blur-3xl animate-float" style={{
      animationDelay: '2s'
    }} data-id="element-82"></div>
      <div className="absolute bottom-1/4 right-0 w-[450px] h-[450px] bg-gradient-to-bl from-purple-400/10 via-indigo-400/5 to-blue-400/10 rounded-[40%_60%_30%_70%] blur-3xl animate-float" style={{
      animationDelay: '3s'
    }} data-id="element-83"></div>
      <div className="container mx-auto px-6 relative" data-id="element-84">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 mb-12 md:mb-20" data-id="element-85">
          {/* Brand and Description */}
          <div className="md:col-span-4" data-id="element-86">
            <a href="#" className="block mb-6" data-id="element-87">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jP7ueorRtM9x7giMYpBsys/nisa-capriola-logotype.png" alt="Nisa" className="h-8 w-auto brightness-0 invert" data-id="element-88" />
            </a>
            <p className="text-teal-100 mb-4 font-medium font-serif" data-id="element-89">
              Coaching simplified.
              <br data-id="element-90" />
              Impact multiplied.
            </p>
            <a href="https://www.linkedin.com/company/nisacoach/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-10 h-10 rounded-md bg-white/10 hover:bg-white/20 transition-colors duration-300" aria-label="Follow Nisa on LinkedIn" data-id="element-91">
              <div className="bg-white text-primary-800 rounded-sm w-5 h-5 flex items-center justify-center" data-id="element-92">
                <Linkedin className="w-4 h-4 fill-current" strokeWidth={0} data-id="element-93" />
              </div>
            </a>
          </div>
          {/* Quick Links */}
          <div className="md:col-span-2" data-id="element-94">
            <h3 className="text-white font-medium mb-4" data-id="element-95">Product</h3>
            <ul className="space-y-3" data-id="element-96">
              <li data-id="element-97">
                <a href="#what-is-nisa" className="text-cyan-100 hover:text-cyan-100/80 transition-colors font-medium" data-id="element-98">
                  What Is Nisa
                </a>
              </li>
              <li data-id="element-99">
                <a href="#features" className="text-cyan-100 hover:text-cyan-100/80 transition-colors font-medium" data-id="element-100">
                  Features
                </a>
              </li>
              <li data-id="element-101">
                <a href="#why-nisa-works" className="text-cyan-100 hover:text-cyan-100/80 transition-colors font-medium" data-id="element-102">
                  Why It Works
                </a>
              </li>
            </ul>
          </div>
          {/* Company Links */}
          <div className="md:col-span-2" data-id="element-103">
            <h3 className="text-white font-medium mb-4" data-id="element-104">Company</h3>
            <ul className="space-y-3" data-id="element-105">
              <li data-id="element-106">
                <a href="/about" className="text-cyan-100 hover:text-cyan-100/80 transition-colors font-medium" data-id="element-107">
                  About Us
                </a>
              </li>
              <li data-id="element-108">
                <a href="/privacy" className="text-cyan-100 hover:text-cyan-100/80 transition-colors font-medium" data-id="element-109">
                  Privacy
                </a>
              </li>
              <li data-id="element-110">
                <a href="/terms" className="text-cyan-100 hover:text-cyan-100/80 transition-colors font-medium" data-id="element-111">
                  Terms
                </a>
              </li>
            </ul>
          </div>
          {/* Newsletter */}
          <div className="md:col-span-4 flex flex-col items-start" data-id="element-112">
            <h3 className="text-white font-medium mb-4" data-id="element-113">Stay Connected</h3>
            <p className="text-grey-300 mb-4" data-id="element-114">
              Get the latest updates from Nisa
            </p>
            <Button variant="outline" size="sm" onClick={openSignupModal} className="text-cyan-100 border-white/30 hover:bg-white/10 transition-all duration-300 hover:shadow-[0_0_10px_2px_rgba(34,211,238,0.4)]" data-id="element-115">
              Stay in the loop
            </Button>
          </div>
        </div>
        {/* Bottom Bar */}
        <div className="border-t border-cyan-700 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-116">
          <p className="text-gray-300 text-sm mb-4 md:mb-0 font-medium" data-id="element-117">
            © {new Date().getFullYear()} Nisa. All rights reserved.
          </p>
          <div className="flex items-center space-x-2" data-id="element-118">
            <span className="text-gray-300 text-sm font-medium" data-id="element-119">
              Powered by
            </span>
            <a href="https://www.teachinglabstudio.com/" target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-blue-400 hover:text-blue-300 transition-colors" data-id="element-120">
              Teaching Lab Studio
            </a>
          </div>
        </div>
      </div>
    </footer>;
};